"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getEnrolmentOfContent_1 = tslib_1.__importDefault(require("./getEnrolmentOfContent"));
const isAssigned_1 = tslib_1.__importDefault(require("./isAssigned"));
function checkIfNonDeletedEnrolmentExists(enrolments, contentId, user) {
    const enrolment = getEnrolmentOfContent_1.default(enrolments, contentId, user.userId);
    return isAssigned_1.default(enrolment);
}
exports.checkIfNonDeletedEnrolmentExists = checkIfNonDeletedEnrolmentExists;
//# sourceMappingURL=checkIfEnrolmentExists.js.map